import FMSynth from 'instruments/FMSynth.js';
import ParameterContext from 'effects/ParameterContext.js';
import InstrumentTrack from './InstrumentTrack.js';

class FMSynthTrack extends InstrumentTrack {
    constructor(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence) {
        super(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence, false);
        this.setInstrument(
            new FMSynth(
                sequencerEngine,
                mixSession,
                new ParameterContext().forTrack(this)));
    }
}

export default FMSynthTrack;
